import { CommunicationService } from "../services/communication.service";
// @ts-ignore
import { LocalStorageService } from "@cosmos/utilities";
import { environment } from "../environments/environment";

export class ChangeLayoutEvent {
  static EVENT_NAME = "changeLayout";
  static logoutEvent: ChangeLayoutEvent;

  private constructor() {
    this.load();
  }

  static init(): ChangeLayoutEvent {
    if (!ChangeLayoutEvent.logoutEvent) {
      ChangeLayoutEvent.logoutEvent = new ChangeLayoutEvent();
    }

    if (LocalStorageService.singleton().has("layout_options")) {
      const emit = new CustomEvent(ChangeLayoutEvent.EVENT_NAME, {
        detail: LocalStorageService.singleton().getItem("layout_options"),
      });
      window.dispatchEvent(emit);
    }
    return ChangeLayoutEvent.logoutEvent;
  }

  static destroy() {}

  load() {
    const communicationService = CommunicationService.singleton();
    communicationService.receiveCustomEvent(
      ChangeLayoutEvent.EVENT_NAME,
      this.changeLayout
    );
  }

  changeLayout: EventListener = async (event: CustomEvent) => {
    const elementMainContainer = document.querySelector(".sspa-launcher__main");
    const elementToolbar = document.querySelector(".sspa-launcher__toolbar");
    const elementSidenav = document.querySelector(".sspa-launcher__sidenav");
    if (!elementMainContainer || !elementToolbar || !elementSidenav) {
      return;
    }

    if ("toolbar" in event.detail) {
      if (event.detail.toolbar) {
        if (
          !elementMainContainer.classList.contains(
            "sspa-launcher__main--no-toolbar"
          )
        ) {
          elementMainContainer.classList.add("sspa-launcher__main--no-toolbar");
        }
        if (
          !elementToolbar.classList.contains(
            "sspa-launcher__toolbar--hidden"
          )
        ) {
          elementToolbar.classList.add("sspa-launcher__toolbar--hidden");
        }
      } else {
        elementMainContainer.classList.remove(
          "sspa-launcher__main--no-toolbar"
        );
        elementToolbar.classList.remove("sspa-launcher__toolbar--hidden");
      }
    }

    if ("sidenav" in event.detail) {
      if (event.detail.sidenav) {
        if (
          !elementSidenav.classList.contains(
            "sspa-launcher__sidenav--hidden"
          )
        ) {
          elementSidenav.classList.add("sspa-launcher__sidenav--hidden");
        }
      } else {
        
        elementSidenav.classList.remove("sspa-launcher__sidenav--hidden");
      }
    }
    const localStorageService = LocalStorageService.singleton();
    localStorageService.setItem("layout_options", event.detail);
  };
}
